/* ZeroFat — عنوان التوصيل: محافظة ← مدينة، ومنها لشيك أوت شوبيفاي مملوء.
 *
 * ⚠️ الخانات بتتحفظ كـ cart attributes **قبل** التحويل للشيك أوت، لأن الشيك أوت
 *    بياخد العنوان للعرض بس — اللي بيوصل للأوردر وبنطلع منه بوليصة بوسطة هو
 *    الـ attributes. لو العميل عدّل «المدينة» في الشيك أوت، الـ attributes
 *    تفضل هي المصدر الموثوق.
 *
 * ⚠️ `/cart/<variant>:<qty>?checkout[...]` بيعمل سلة **جديدة** وبيضيّع
 *    الخصائص. عشان كده بنستخدم السلة الموجودة ثم `/checkout?checkout[...]`.
 *
 * ⚠️ خانة «الحي» اتشالت ٧ أكتوبر ٢٠٢٦ — بوسطة مش محتاجاها، وتلات خانات كانت
 *    احتكاك زيادة. لسه بنبعت `bosta_district_id` لوحده لما المدينة يكون جواها
 *    حي واحد بس (`z.o` في البيانات) — ٣٥٣ مدينة من ٥٣٨.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-zaddr]');
  var DATA = window.ZF_AREAS;
  if (!root || !DATA || !DATA.c) return;

  var LS = 'zf:addr:v4';
  var AR = '٠١٢٣٤٥٦٧٨٩';

  /* ======================= كومبوبوكس بسيرش =======================
   * بديل الـ <select>: القاهرة لوحدها ٥٥ مدينة — السكرول مش حل.
   * الاختيار بيتخزّن في `<input type="hidden" data-zf="…">` فبوست الفورم
   * العادي شغال زي ما هو.
   */
  function Combo(mount, input, opts) {
    var items = [];
    var open = false;
    var cursor = -1;
    var shown = [];

    var box = document.createElement('div');
    box.className = 'zcb';
    box.innerHTML =
      '<button type="button" class="zcb-btn" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="zcb-val"></span>' +
        '<svg class="zcb-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<div class="zcb-pop" hidden>' +
        '<div class="zcb-top">' +
          '<div class="zcb-sw">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20l-3.6-3.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
            '<input type="search" class="zcb-search" autocomplete="off" enterkeyhint="done">' +
          '</div>' +
          '<button type="button" class="zcb-x" aria-label="إغلاق">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<ul class="zcb-list" role="listbox" tabindex="-1"></ul>' +
        '<p class="zcb-none" hidden>مفيش نتيجة بالاسم ده</p>' +
      '</div>';
    mount.appendChild(box);

    var btn = box.querySelector('.zcb-btn');
    var val = box.querySelector('.zcb-val');
    var pop = box.querySelector('.zcb-pop');
    var search = box.querySelector('.zcb-search');
    var list = box.querySelector('.zcb-list');
    var none = box.querySelector('.zcb-none');
    search.placeholder = opts.searchPlaceholder || 'دوّر…';

    /* بنشيل التشكيل وبنوحّد الألف والياء والتاء المربوطة — الناس بتكتب
       «الدقي» و«الدقى»، و«مصر الجديده» و«مصر الجديدة». */
    function norm(s) {
      return String(s || '')
        .replace(/[ً-ْـ]/g, '')
        .replace(/[أإآٱ]/g, 'ا')
        .replace(/ى/g, 'ي')
        .replace(/ة/g, 'ه')
        .replace(/[0-9]/g, function (d) { return AR[+d]; })
        .toLowerCase().trim();
    }

    function paint() {
      var q = norm(search.value);
      shown = q ? items.filter(function (it) { return it.k.indexOf(q) >= 0; }) : items.slice();
      if (q) {
        /* اللي بيبدأ بالكلمة يطلع فوق */
        shown.sort(function (a, b) {
          return (a.k.indexOf(q) === 0 ? 0 : 1) - (b.k.indexOf(q) === 0 ? 0 : 1);
        });
      }
      list.textContent = '';
      cursor = -1;
      for (var i = 0; i < shown.length; i++) {
        var li = document.createElement('li');
        li.className = 'zcb-o';
        li.setAttribute('role', 'option');
        li.dataset.v = shown[i].i;
        li.textContent = shown[i].n;
        if (shown[i].i === input.value) {
          li.classList.add('on');
          li.setAttribute('aria-selected', 'true');
          cursor = i;
        }
        list.appendChild(li);
      }
      none.hidden = shown.length > 0;
      if (cursor >= 0) list.children[cursor].scrollIntoView({ block: 'nearest' });
    }

    function label() {
      var hit = items.filter(function (it) { return it.i === input.value; })[0];
      val.textContent = hit ? hit.n : (opts.placeholder || 'اختار…');
      box.classList.toggle('filled', !!hit);
    }

    function show() {
      if (open || btn.disabled) return;
      open = true;
      pop.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      box.classList.add('open');
      document.body.classList.add('zcb-lock');
      search.value = '';
      paint();
      setTimeout(function () { search.focus(); }, 30);
    }
    function hide(back) {
      if (!open) return;
      open = false;
      pop.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      box.classList.remove('open');
      document.body.classList.remove('zcb-lock');
      if (back !== false) btn.focus();
    }
    function pick(v) {
      input.value = v;
      label();
      hide();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    btn.addEventListener('click', function () { if (open) { hide(); } else { show(); } });
    box.querySelector('.zcb-x').addEventListener('click', function () { hide(); });
    search.addEventListener('input', paint);
    list.addEventListener('click', function (e) {
      var o = e.target.closest('.zcb-o');
      if (o) pick(o.dataset.v);
    });

    function move(step) {
      if (!shown.length) return;
      var prev = list.children[cursor];
      if (prev) prev.classList.remove('cur');
      cursor = (cursor + step + shown.length) % shown.length;
      var li = list.children[cursor];
      li.classList.add('cur');
      li.scrollIntoView({ block: 'nearest' });
    }
    box.addEventListener('keydown', function (e) {
      if (!open) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') { e.preventDefault(); show(); }
        return;
      }
      if (e.key === 'Escape') { e.preventDefault(); hide(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        var li = list.children[cursor] || (shown.length === 1 ? list.children[0] : null);
        if (li) pick(li.dataset.v);
      }
    });
    document.addEventListener('click', function (e) {
      if (open && !box.contains(e.target)) hide(false);
    });

    label();   /* من غير دي الخانة بتفضل فاضية لحد أول set() */

    return {
      set: function (next, keep) {
        items = (next || []).map(function (it) { return { i: it.i, n: it.n, k: norm(it.n) }; });
        if (!keep || !items.some(function (it) { return it.i === input.value; })) input.value = '';
        label();
        if (open) paint();
      },
      disable: function (off) {
        btn.disabled = !!off;
        box.classList.toggle('off', !!off);
        if (off) hide(false);
      },
      sync: label
    };
  }

  /* ======================= الخانات ======================= */

  var el = function (k) { return root.querySelector('[data-zf="' + k + '"]'); };
  var hidden = function (k) { return root.querySelector('[data-zf-hidden="' + k + '"]'); };
  var F = {
    name: el('name'), phone: el('phone'), email: el('email'),
    news: el('news'), street: el('street'), landmark: el('landmark'),
    building: el('building'), floor: el('floor'), apartment: el('apartment'),
    city: el('city'), zone: el('zone')
  };
  var savedNote = root.querySelector('[data-zaddr-saved]');

  var CB = {
    city: Combo(root.querySelector('[data-zcb="city"]'), F.city, {
      placeholder: 'اختار المحافظة', searchPlaceholder: 'دوّر على محافظة…'
    }),
    zone: Combo(root.querySelector('[data-zcb="zone"]'), F.zone, {
      placeholder: 'اختار المحافظة الأول', searchPlaceholder: 'دوّر على مدينة…'
    })
  };

  var cityBy = function (id) { return DATA.c.filter(function (c) { return c.i === id; })[0] || null; };
  var zoneBy = function (city, id) {
    return city ? (city.z.filter(function (z) { return z.i === id; })[0] || null) : null;
  };

  CB.city.set(DATA.c);
  CB.zone.disable(true);

  function onCity() {
    var c = cityBy(F.city.value);
    CB.zone.disable(!c);
    CB.zone.set(c ? c.z : [], false);
  }

  F.city.addEventListener('change', function () { onCity(); clearHint('city'); flush(); });
  F.zone.addEventListener('change', function () { clearHint('zone'); flush(); });

  /* ======================= الموبايل والتحقق ======================= */

  function normPhone(v) {
    var s = String(v || '').replace(/[٠-٩]/g, function (d) { return AR.indexOf(d); });
    s = s.replace(/[^\d]/g, '');
    if (s.indexOf('0020') === 0) s = s.slice(4);
    else if (s.indexOf('20') === 0 && s.length > 11) s = s.slice(2);
    if (s.length === 10 && s.charAt(0) === '1') s = '0' + s;
    return s;
  }
  var PHONE_OK = /^01[0125]\d{8}$/;
  var EMAIL_OK = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function current() {
    var val = function (k) {
      return (F[k] ? F[k].value : '').trim().replace(/\s+/g, ' ');
    };
    var c = cityBy(F.city.value);
    var z = zoneBy(c, F.zone.value);
    return {
      name: (F.name.value || '').trim().replace(/\s+/g, ' '),
      phone: normPhone(F.phone.value),
      email: (F.email.value || '').trim(),
      news: !!(F.news && F.news.checked),
      street: (F.street.value || '').trim().replace(/\s+/g, ' '),
      landmark: val('landmark'),
      building: val('building'),
      floor: val('floor'),
      apartment: val('apartment'),
      cityId: c ? c.i : '', cityName: c ? c.n : '', prov: c ? c.p : '',
      zoneId: z ? z.i : '', zoneName: z ? z.n : '',
      /* كود الحي بيروح لوحده لما المدينة جواها حي واحد بس */
      districtId: (z && z.o) || ''
    };
  }

  function hint(k, msg) {
    var h = root.querySelector('[data-zf-hint="' + k + '"]');
    if (h) { h.textContent = msg; h.hidden = false; }
    var f = root.querySelector('[data-zf-field="' + k + '"]');
    if (f) f.classList.add('bad');
    if (F[k]) F[k].classList.add('bad');
  }
  function clearHint(k) {
    var h = root.querySelector('[data-zf-hint="' + k + '"]');
    if (h) h.hidden = true;
    var f = root.querySelector('[data-zf-field="' + k + '"]');
    if (f) f.classList.remove('bad');
    if (F[k]) F[k].classList.remove('bad');
  }

  function focusField(k) {
    var target = CB[k] ? root.querySelector('[data-zf-field="' + k + '"] .zcb-btn') : F[k];
    if (!target) return;
    target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }

  function validate() {
    ['name', 'phone', 'email', 'street', 'city', 'zone'].forEach(clearHint);
    var v = current();
    var bad = [];
    if (!v.cityId) { hint('city', 'اختار المحافظة.'); bad.push('city'); }
    else if (!v.zoneId) { hint('zone', 'اختار المدينة.'); bad.push('zone'); }
    if (v.street.length < 8) { hint('street', 'العنوان قصير — اكتب الشارع ورقم العمارة والدور.'); bad.push('street'); }
    if (v.name.length < 4 || v.name.indexOf(' ') < 0) { hint('name', 'اكتب الاسم الأول واسم العيلة.'); bad.push('name'); }
    if (!PHONE_OK.test(v.phone)) { hint('phone', 'رقم موبايل مصري ١١ رقم، يبدأ بـ ٠١٠ أو ٠١١ أو ٠١٢ أو ٠١٥.'); bad.push('phone'); }
    /* الإيميل اختياري — بس لو اتكتب لازم يبقى شكله صح */
    if (v.email && !EMAIL_OK.test(v.email)) { hint('email', 'الإيميل مش مظبوط — سيبه فاضي لو مش عايز تكتبه.'); bad.push('email'); }
    if (bad.length) { focusField(bad[0]); return null; }
    return v;
  }

  /* ======================= الحفظ والتحويل ======================= */

  function mirror(v) {
    var map = {
      cityName: v.cityName, zoneName: v.zoneName,
      cityId: v.cityId, zoneId: v.zoneId, districtId: v.districtId,
      news: v.news ? 'نعم' : 'لا'
    };
    Object.keys(map).forEach(function (k) {
      var i = hidden(k);
      if (i) i.value = map[k];
    });
  }

  function remember(v) {
    try {
      localStorage.setItem(LS, JSON.stringify({
        name: v.name, phone: v.phone, email: v.email, news: v.news,
        street: v.street, landmark: v.landmark,
        building: v.building, floor: v.floor, apartment: v.apartment,
        cityId: v.cityId, zoneId: v.zoneId
      }));
    } catch (e) {}
  }

  function attrs(v) {
    return {
      'الاسم': v.name,
      'الموبايل': v.phone,
      'الإيميل': v.email,
      'نشرة العروض': v.news ? 'نعم' : 'لا',
      'المحافظة': v.cityName,
      'المدينة': v.zoneName,
      'العنوان': v.street,
      'العمارة': v.building,
      'الدور': v.floor,
      'الشقة': v.apartment,
      'علامة مميزة': v.landmark,
      'bosta_city_id': v.cityId,
      'bosta_zone_id': v.zoneId,
      'bosta_district_id': v.districtId
    };
  }

  function save(v) {
    mirror(v);
    remember(v);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs(v) })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed: ' + r.status);
      return r.json();
    });
  }

  /* شيك أوت شوبيفاي بيتملّى من الكويري.
     المدينة = اللي العميل اختارها من ليستة بوسطة (ده اللي المندوب بيقراه).
     ⚠️ وبنبعت `billing_address` بنفس القيم عشان الشيك أوت ميفتحش قسم
     «عنوان مختلف للفواتير» ويخلّي العميل يكتب العنوان تاني. */
  function checkoutUrl(v) {
    var parts = v.name.split(' ');
    var first = parts.shift();
    var last = parts.join(' ') || '-';
    /* السطر التاني من العنوان: العمارة والدور والشقة والعلامة المميزة
       مجمّعين في سطر واحد — ده اللي بيطلع على بوليصة الشحن تحت العنوان.
       وكل حتة لسه لها خصيصة لوحدها عشان السيستم يقراها منفصلة. */
    var line2 = [
      v.building ? 'عمارة ' + v.building : '',
      v.floor ? 'الدور ' + v.floor : '',
      v.apartment ? 'شقة ' + v.apartment : '',
      v.landmark
    ].filter(Boolean).join(' · ');

    var q = new URLSearchParams();
    /* معلومات الاتصال — أول خطوة في شيك أوت شوبيفاي.
       ⚠️ مفيش `checkout[buyer_accepts_marketing]` هنا عن قصد: اتجرّب على المتجر
       (٧ أكتوبر ٢٠٢٦) ومالوش **أي** تأثير — خانة النشرة في الشيك أوت بتفضل
       مش متعلّمة سواء بعتناه =1 أو =0 أو مابعتناهوش.
       موافقة العميل بتتسجّل عندنا في خصيصة «نشرة العروض» على الأوردر. */
    if (v.email) q.set('checkout[email]', v.email);
    ['shipping_address', 'billing_address'].forEach(function (kind) {
      var p = 'checkout[' + kind + ']';
      q.set(p + '[first_name]', first);
      q.set(p + '[last_name]', last);
      q.set(p + '[address1]', v.street);
      if (line2) q.set(p + '[address2]', line2);
      q.set(p + '[city]', v.zoneName);
      q.set(p + '[province]', v.prov);
      q.set(p + '[country]', 'Egypt');
      q.set(p + '[phone]', v.phone);
    });
    return '/checkout?' + q.toString();
  }

  /* ======================= الاسترجاع ======================= */

  function restore() {
    var s = null;
    var fromCart = root.getAttribute('data-zaddr-cart');
    if (fromCart) {
      try {
        var c = JSON.parse(fromCart);
        if (c && c.cityId) s = c;   /* فاضية = مفيش حاجة على السلة */
      } catch (e) {}
    }
    if (!s) { try { s = JSON.parse(localStorage.getItem(LS) || 'null'); } catch (e) {} }
    if (!s) return;

    if (s.name && !F.name.value) F.name.value = s.name;
    if (s.phone && !F.phone.value) F.phone.value = s.phone;
    if (s.email && !F.email.value) F.email.value = s.email;
    if (s.street && !F.street.value) F.street.value = s.street;
    ['landmark', 'building', 'floor', 'apartment'].forEach(function (k) {
      if (s[k] && F[k] && !F[k].value) F[k].value = s[k];
    });
    /* النشرة متعلّمة من ليكويد؛ مابنغيّرهاش غير لو العميل شالها قبل كده */
    if (F.news && s.news === false) F.news.checked = false;

    var c2 = cityBy(s.cityId);
    if (!c2) return;
    F.city.value = s.cityId;
    CB.city.sync();
    CB.zone.disable(false);
    CB.zone.set(c2.z, false);
    if (s.zoneId && zoneBy(c2, s.zoneId)) {
      F.zone.value = s.zoneId;
      CB.zone.sync();
    }
    mirror(current());
  }
  restore();

  F.phone.addEventListener('input', function () {
    var n = normPhone(F.phone.value);
    if (n !== F.phone.value) F.phone.value = n;
    clearHint('phone');
  });
  ['name', 'street', 'email', 'landmark', 'building', 'floor', 'apartment'].forEach(function (k) {
    F[k].addEventListener('input', function () { clearHint(k); });
  });

  /* ======================= البوابة ======================= */

  var going = false;
  var flushTimer = null;

  function proceed(btn) {
    if (going) return;
    var v = validate();
    if (!v) return;
    going = true;
    if (btn) btn.classList.add('busy');
    clearTimeout(flushTimer);   /* ماينفعش حفظين على بعض */

    save(v)
      .then(function () {
        if (savedNote) savedNote.hidden = false;
        window.location.href = checkoutUrl(v);
      })
      .catch(function () {
        /* ⚠️ مش بنعمل form.submit() هنا: الـ submit البرمجي مفيهوش submitter،
           يعني `name="checkout"` مبيتبعتش والشيك أوت مبيفتحش — العميل يدوس
           ويحس إن مفيش حاجة حصلت. بنقوله يجرّب تاني بدل كده.
           (لو الجافاسكريبت مقفول خالص، الفورم بيبوست لوحده والخانات
            المخفية بتسجّل العنوان — دي الشبكة الحقيقية.) */
        going = false;
        if (btn) btn.classList.remove('busy');
        hint('street', 'النت قطع والعنوان ماتسجّلش — جرّب تدوس تاني.');
      });
  }

  /* فورم السلة فيه زرار submit واحد بس — `name="checkout"` — وباقي الزراير
     `type="button"`. فاعتراض كل submit صح، و Enter في أي خانة بيعدّي عليه بردو.
     `e.submitter` مش مدعوم في سفاري القديم، فبنستخدمه للـ spinner بس. */
  var cartForm = root.closest('form');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      proceed(e.submitter || cartForm.querySelector('[name="checkout"]'));
    });
  }

  /* احفظ على السلة ساعة ما العميل يسيب الخانات — لو سافر من غير ما يدوس الزرار */
  function flush() {
    var v = current();
    mirror(v);
    if (!v.cityId || !v.zoneId) return;
    remember(v);
    clearTimeout(flushTimer);
    flushTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs(v) })
      }).catch(function () {});
    }, 700);
  }
  if (F.news) F.news.addEventListener('change', function () { mirror(current()); flush(); });
  root.addEventListener('change', flush);
  root.addEventListener('blur', flush, true);
})();
